<ph-card *ngIf="payload" flat [heading]="payload.title">
    <ph-badge slot="actions" *ngIf="payload.badge" variant="light" color="blue">{{ payload.badge }}</ph-badge>

    <ph-stack gap="tight">
        <ph-list-row *ngFor="let item of payload.items; trackBy: trackByIndex" [heading]="item.title" [meta]="item.meta || ''">
            <ph-toolbar slot="actions" nowrap *ngIf="item.value || item.recommendation">
                <ph-label *ngIf="item.value">{{ item.value }}</ph-label>
                <ph-button *ngIf="item.recommendation" size="xsmall"
                           [variant]="buttonVariant(item)" [mode]="buttonMode(item)"
                           (click)="onItemAction(item)">{{ item.recommendation }}</ph-button>
            </ph-toolbar>
            <ph-stack slot="detail" gap="tight" *ngIf="item.tag || item.reason || item.href || item.confidencePct != null">
                <ph-toolbar *ngIf="item.tag || item.confidencePct != null">
                    <ph-badge *ngIf="item.tag" size="small" variant="light" color="blue">{{ item.tag }}</ph-badge>
                    <ph-hint *ngIf="item.confidencePct != null">{{ item.confidencePct }}% confident</ph-hint>
                </ph-toolbar>
                <ph-hint *ngIf="item.reason">{{ item.reason }}</ph-hint>
                <ph-link-button *ngIf="item.href" size="small" icon="arrow-square-out" [attr.href]="item.href">Open</ph-link-button>
            </ph-stack>
        </ph-list-row>
    </ph-stack>

    <ph-hint slot="footer" *ngIf="payload.footnote">{{ payload.footnote }}</ph-hint>
</ph-card>
